/**
 * App area bundle: the vendor libraries the app screens expect as globals, the
 * app stylesheet, and the behaviour shared by every app page.
 *
 * Inline `@push('scripts')` blocks run after this bundle, so `$`, `bootstrap`
 * and `Parsley` are available to them.
 */
import './app/jquery-global.js';
import * as bootstrap from 'bootstrap';
import 'parsleyjs';
import 'select2';

import 'bootstrap-icons/font/bootstrap-icons.css';
import 'select2/dist/css/select2.min.css';
import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.min.css';
import '../sass/app.scss';

window.bootstrap = bootstrap;

$(document).ready(function () {
    // Select2's default `width: 'resolve'` freezes the container at the pixel
    // width the select happens to have at init, so a control in a panel that
    // gains or loses a scrollbar afterwards stops lining up with the plain
    // fields around it. `100%` leaves the width to the browser instead.
    $('.js-select2').select2({
        theme: 'bootstrap-5',
        width: '100%',
    });
});

$(document).on('change', '.js-data-blur-mode-switch', function () {
    this.form.submit();
});
